import { formatDateOrDash, formatDateTimeOrDash } from '#/utils/date';

export function mapRepairReportMeta(detail) {
  const inspection = detail?.inspection;
  const history = detail?.history;
  const inspectionItems = Array.isArray(detail?.inspectionItems)
    ? detail.inspectionItems
    : (Array.isArray(inspection?.inspectionItems) ? inspection.inspectionItems : []);

  return {
    code: detail?.repairReportNo || '-',
    status: detail?.status || '',
    repairDate: formatDateOrDash(detail?.repairDate),
    serialNo: detail?.serialNo || '',
    itemName: detail?.itemName || '',
    problemDescription: detail?.problemDescription || '',
    accessories: detail?.accessories || '',
    resolution: detail?.resolution || '',
    remark: detail?.remark || '',
    inspectionConclusion: detail?.inspectionConclusion
      ?? inspection?.inspectionConclusion
      ?? '',
    refuseReason: detail?.refuseReason ?? history?.refuseReason ?? '',
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    completedAt: formatDateTimeOrDash(history?.completedAt),
    refusedAt: formatDateTimeOrDash(history?.refusedAt),
    cancelledAt: formatDateTimeOrDash(history?.cancelledAt),
    cancelReason: history?.cancelReason ?? '',
    inspectionItemCount: inspectionItems.length,
  };
}

export function createEmptyInspectionItem() {
  return {
    description: '',
    result: 'PASS',
  };
}

/**
 * 編輯表單 hydrate。序號／品名／問題描述／配件為 repair_item 快照唯讀，不進可編欄位。
 */
export function mapRepairReportDetailToFormValues(detail) {
  const inspection = detail?.inspection;
  const inspectionItems = Array.isArray(detail?.inspectionItems)
    ? detail.inspectionItems
    : (Array.isArray(inspection?.inspectionItems) ? inspection.inspectionItems : []);

  return {
    repairDate: detail?.repairDate ?? '',
    resolution: detail?.resolution ?? '',
    remark: detail?.remark ?? '',
    inspectionConclusion: detail?.inspectionConclusion
      ?? inspection?.inspectionConclusion
      ?? '',
    inspectionItems: (inspectionItems.length > 0
      ? inspectionItems
      : [{ description: '', result: 'PASS' }]
    ).map((item) => ({
      description: item?.description ?? '',
      result: item?.result ?? 'PASS',
    })),
  };
}

/**
 * PATCH write payload。**不送** serialNo／itemName／accessories／problemDescription（BE 唯讀快照）。
 */
export function buildRepairReportWritePayload(values, { updatedAt = null } = {}) {
  const payload = {
    repairDate: values?.repairDate || null,
    resolution: values?.resolution || null,
    remark: values?.remark || null,
    inspectionConclusion: values?.inspectionConclusion || null,
    inspectionItems: (values?.inspectionItems ?? []).map((item) => ({
      description: item?.description ?? null,
      result: item?.result ?? null,
    })),
  };

  if (updatedAt) {
    payload.updatedAt = updatedAt;
  }

  return payload;
}
